import React, { useState, useEffect } from 'react'
import { StyleSheet, View, Image, SafeAreaView, Platform } from 'react-native'
import { Text, Button, ViewPager, Icon, useTheme } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'

export default function WelcomeScreen({ navigation }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const [pageIndex, setPageIndex] = useState(0)

  useEffect(() => {
    navigation.setOptions({
      headerShown: false
    })
  }, [])

  return (
    <SafeAreaView style={[styles.container, {backgroundColor: theme['background-basic-color-1']}]}>
      <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'stretch', marginTop: Platform.OS === 'ios' ? 10 : 30, marginBottom: 10, marginHorizontal: 20}}>
        <View>
          <Text category='h5' style={styles.title}>ATLAS</Text>
        </View>
        <Image source={require('../../assets/almaty.png')} style={{width: 50, height: 50, resizeMode: 'contain', alignSelf: 'flex-end'}}/>
      </View>
      <ViewPager style={styles.viewPager} selectedIndex={pageIndex} onSelect={setPageIndex} useNativeDriver={true}>
        <View key='1' style={styles.page}>
          <Image source={require('../../assets/platform.png')} style={styles.image}/>
          <Text style={styles.header} category='h2'>{t('welcome.header1')}</Text>
          <Text style={styles.text} category='s1'>{t('welcome.text1')}</Text>
        </View>
        <View key='2' style={styles.page}>
          <Image source={require('../../assets/investor_update.png')} style={styles.image}/>
          <Text style={styles.header} category='h2'>{t('welcome.header2')}</Text>
          <Text style={styles.text} category='s1'>{t('welcome.text2')}</Text>
        </View>
        <View key='3' style={styles.page}>
          <Image source={require('../../assets/in_sync.png')} style={styles.image}/>
          <Text style={styles.header} category='h2'>{t('welcome.header3')}</Text>
          <Text style={styles.text} category='s1'>{t('welcome.text3')}</Text>
        </View>
        <View key='4' style={styles.page}>
          <Image source={require('../../assets/visual_data.png')} style={styles.image}/>
          <Text style={styles.header} category='h2'>{t('welcome.header4')}</Text>
          <Text style={styles.text} category='s1'>{t('welcome.text4')}</Text>
        </View>
        <View key='5' style={styles.page}>
          <Image source={require('../../assets/sharing.png')} style={styles.image}/>
          <Text style={styles.header} category='h2'>{t('welcome.header5')}</Text>
          <Text style={styles.text} category='s1'>{t('welcome.text5')}</Text>
        </View>
      </ViewPager>
      <View style={{marginBottom: 20, flexDirection: 'row'}}>
        <Icon name={pageIndex == 0 ? 'radio-button-on' : 'radio-button-off-outline'} width={10} height={10} fill={theme['color-primary-500']} />
        <Icon name={pageIndex == 1 ? 'radio-button-on' : 'radio-button-off-outline'} width={10} height={10} fill={theme['color-primary-500']} />
        <Icon name={pageIndex == 2 ? 'radio-button-on' : 'radio-button-off-outline'} width={10} height={10} fill={theme['color-primary-500']} />
        <Icon name={pageIndex == 3 ? 'radio-button-on' : 'radio-button-off-outline'} width={10} height={10} fill={theme['color-primary-500']} />
        <Icon name={pageIndex == 4 ? 'radio-button-on' : 'radio-button-off-outline'} width={10} height={10} fill={theme['color-primary-500']} />
      </View>
      <Button appearance='outline' onPress={() => navigation.navigate('Login')} style={styles.loginButton}>{t('login.loginCTA')}</Button>
      <Button onPress={() => navigation.navigate('Funnel')} style={styles.signUpButton}>{t('login.register')}</Button>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'center',
  },
  title: {
    // marginHorizontal: 20,
    marginVertical: 10,
    textAlign: 'center'
  },
  image: {
    // width: '80%',
    height: 200,
    width: 300,
    resizeMode: 'contain',
    marginBottom: 10
  },
  viewPager: {
    flex: 1,
    alignSelf: 'stretch',
  },
  page:{
    flex: 1,
    alignItems: 'center',
    // marginTop: 50
    justifyContent: 'center',
    maxWidth: 600,
    alignSelf: 'center'
  },
  header: {
    marginBottom: 10,
    paddingHorizontal: 20,
    textAlign: 'center'
    // alignSelf: 'flex-start'
  },
  text: {
    paddingHorizontal: 20,
    textAlign: 'center',
    // alignSelf: 'flex-start'
  },
  loginButton: {
    alignSelf: 'stretch',
    marginBottom: 10,
    marginHorizontal: 20,
    // marginTop: 'auto'
  },
  signUpButton: {
    alignSelf: 'stretch',
    marginBottom: 20,
    marginHorizontal: 20
  }
})
